import { ListAssetPage } from "../list_asset"
import { AssetCategoryApi, AssetAreaApi, FacilityApi, AssetApi, AssetLoanApi, TabletApi } from "../../api/api"
import { AssetMgtPageLoaderBase } from "./index"
import { Asset, PagedListResult } from "../../api/model"
/**
 * 頁面 /community/assetList.aspx 執行此 Page loader
 */
export class AssetMgtListAssetLoader extends AssetMgtPageLoaderBase {

    private page: ListAssetPage
    private initCategories: Promise<void>
    private initFacilities: Promise<void>
    private initAreas: Promise<void>
    private initAssets: Promise<PagedListResult<Asset>>

    constructor() {
        super()
        this.page = new ListAssetPage(
            new AssetApi(), 
            new AssetCategoryApi(), 
            new FacilityApi(), 
            new AssetAreaApi(),
            new TabletApi(),
            new AssetLoanApi()
        )
    }

    async load(): Promise<void> {
        this.initCategories = this.page.initCategories()
        this.initFacilities = this.page.initFacilities()
        this.initAreas = this.page.initAreas()
        this.initAssets = this.page.queryAssets()
    }

    async loadOnDocumentReady(): Promise<void> {
        console.log("%s loadOnDocumentReady", this)
        //Init no depedency first
        this.page.listenLoanRecordStatusChange()
        this.page.listenLoanReturnBtn()
        this.page.initPagination()
        this.page.updateBackPageLink()
        this.page.listenTypeClick()
        this.page.initCodeScan()
        this.page.initLoanRecordModal()
        this.page.listenFacilityIdsChange()
        this.page.listenNoteChange()
        //this.page.listenAddBtnClick() //Dependencies - create item data
        this.page.listenFacilityEnable()
        this.page.listenEditClick()
        this.page.listenCancelEditClick()
        this.page.listenExportClick()
        this.page.listenSearchClick()
        this.page.listenCleanFilterClick()
        this.page.listenCheckAllClick()
        this.page.listenItemDeleteClick()
        this.page.listenItemUpdateClick()
        this.page.listenDeleteClick()
        //this.page.listenDeleteClick()
        //Init Modal
        this.page.initFacilityModal()
        this.page.initNoteModal()


        //Init asset help data
        await Promise.all([this.initAreas, this.initCategories, this.initFacilities])
        this.page.initSearchElms()
        this.page.initFacilityElms()
        this.page.queryByFilterElms()
        //const assets = await this.initAssets
        //this.page.fillAssetListData(assets.data)
        //this.page.listenStatusFilterChange()
        this.page.listenSortChange()

        //this.page.listenCreateClick()

    }

}
